import Dropdown from '@jetbrains/ring-ui-built/components/dropdown/dropdown'
import Theme, {useThemeClasses} from '@jetbrains/ring-ui-built/components/global/theme'
import {Directions} from '@jetbrains/ring-ui-built/components/popup/popup.consts'
import cn from 'classnames'
import type {ReactNode} from 'react'
import {useMemo} from 'react'

import TransformText from '../../../containers/TransformText'
import {useDistanceToNow} from '../../../hooks/useTimeSelector'
import type {BuildTypeId} from '../../../types'
import Popup from '../Popup/Popup.lazy'

import styles from './CommentPopup.module.css'

type Props = {
  anchor: React.ReactElement<any>
  actionTitle?: string
  timestamp?: string | null | undefined
  user?: string | null | undefined
  text: string | null | undefined
  className?: string
  buildTypeId?: BuildTypeId | null | undefined
  top?: number
  left?: number
  directions?: ReadonlyArray<Directions>
  lines?: number
  actions?: ReactNode
}
const DEFAULT_POPUP_DIRECTIONS = [Directions.RIGHT_BOTTOM, Directions.LEFT_BOTTOM]
const DEFAULT_POPUP_LEFT = 3
const TOP = 8

function CommentPopup({
  anchor,
  actionTitle,
  timestamp,
  user,
  text,
  className,
  buildTypeId,
  top,
  left,
  directions,
  lines,
  actions,
}: Props) {
  const classes = cn(styles.commentPopup, className, {[styles.small]: !!actions})
  const timestampFromNow = useDistanceToNow(timestamp)
  const themeClasses = useThemeClasses(Theme.DARK)
  const popup = useMemo(
    () => (
      <Popup
        directions={actions ? [Directions.BOTTOM_CENTER] : directions || DEFAULT_POPUP_DIRECTIONS}
        className={cn(styles.popupParent, {[themeClasses]: actions})}
        left={left ?? DEFAULT_POPUP_LEFT}
        top={actions ? TOP : top}
      >
        <div className={classes}>
          {text != null && (
            <TransformText
              text={text}
              lines={lines}
              className={styles.text}
              buildTypeId={buildTypeId}
              showPlaceholder={false}
            />
          )}
          {(user != null || timestamp != null) && (
            <div className={cn(styles.info, {[styles.infoSmall]: !!actions})}>
              {actionTitle != null && `${actionTitle}`}
              {user != null && ` by ${user}`}
              {timestampFromNow != null && ` ${timestampFromNow}.`}
            </div>
          )}
          {actions}
        </div>
      </Popup>
    ),
    [
      actions,
      directions,
      themeClasses,
      left,
      top,
      classes,
      text,
      lines,
      buildTypeId,
      user,
      timestamp,
      actionTitle,
      timestampFromNow,
    ],
  )
  return (
    <Dropdown anchor={anchor} hoverHideTimeOut={300} clickMode={false} hoverMode>
      {popup}
    </Dropdown>
  )
}

export default CommentPopup
